module.exports = __webpack_public_path__ + "img/blue-notification.6fa37ceb.svg";